import { StyleSheet } from '@react-pdf/renderer'
import { PDF_COLORS } from 'features/reporting/pdfGeneration/constants/colors'
import { PDF_LAYOUT } from 'features/reporting/pdfGeneration/constants/layout'
import { PDF_TYPOGRAPHY } from 'features/reporting/pdfGeneration/constants/typography'

// Keep headings with roughly three rows of following content.
export const PDF_HEADING_MIN_PRESENCE = 70

export const PdfStyles = StyleSheet.create({
  sectionCard: {
    marginBottom: PDF_LAYOUT.SPACING.XLARGE,
    borderWidth: PDF_LAYOUT.BORDER_WIDTH.NORMAL,
    borderColor: PDF_COLORS.BORDER_MEDIUM,
    borderRadius: PDF_LAYOUT.BORDER_RADIUS.SMALL,
  },

  sectionCardTitle: {
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.MEDIUM,
    fontWeight: 'bold',
    fontFamily: PDF_TYPOGRAPHY.FONT_FAMILY.BOLD,
    color: PDF_COLORS.TEXT_LIGHT,
    backgroundColor: PDF_COLORS.PRIMARY,
    padding: `${PDF_LAYOUT.SPACING.MEDIUM}px ${PDF_LAYOUT.SPACING.LARGE}px`,
    borderTopLeftRadius: PDF_LAYOUT.BORDER_RADIUS.SMALL,
    borderTopRightRadius: PDF_LAYOUT.BORDER_RADIUS.SMALL,
  },

  sectionCardBody: {
    padding: PDF_LAYOUT.SPACING.LARGE,
  },

  descriptionRow: {
    flexDirection: 'row',
    borderBottomWidth: PDF_LAYOUT.BORDER_WIDTH.THIN,
    borderBottomColor: PDF_COLORS.BORDER_LIGHT,
    minHeight: 28,
  },

  // 30% label column: long question-style labels wrap without the aggressive
  // hyphenation a narrower column forces on Helvetica.
  descriptionLabel: {
    width: '30%',
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.SMALL,
    fontWeight: 'bold',
    fontFamily: PDF_TYPOGRAPHY.FONT_FAMILY.BOLD,
    color: PDF_COLORS.TEXT_SECONDARY,
    padding: `${PDF_LAYOUT.SPACING.MEDIUM}px ${PDF_LAYOUT.SPACING.LARGE}px`,
    backgroundColor: PDF_COLORS.BACKGROUND_LIGHT_GRAY,
    borderRightWidth: PDF_LAYOUT.BORDER_WIDTH.THIN,
    borderRightColor: PDF_COLORS.BORDER_LIGHT,
  },

  descriptionValue: {
    width: '70%',
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.SMALL,
    color: PDF_COLORS.TEXT_PRIMARY,
    padding: `${PDF_LAYOUT.SPACING.MEDIUM}px ${PDF_LAYOUT.SPACING.LARGE}px`,
    lineHeight: PDF_TYPOGRAPHY.LINE_HEIGHT.RELAXED,
  },

  preformattedText: {
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.SMALL,
    color: PDF_COLORS.TEXT_PRIMARY,
    lineHeight: PDF_TYPOGRAPHY.LINE_HEIGHT.RELAXED,
  },

  stackedRow: {
    marginTop: PDF_LAYOUT.SPACING.MEDIUM,
  },

  stackedLabel: {
    fontFamily: PDF_TYPOGRAPHY.FONT_FAMILY.BOLD,
    color: PDF_COLORS.TEXT_SECONDARY,
  },

  table: {
    width: '100%',
    marginBottom: PDF_LAYOUT.SPACING.MEDIUM,
    borderWidth: PDF_LAYOUT.BORDER_WIDTH.THIN,
    borderColor: PDF_COLORS.BORDER_LIGHT,
  },

  tableHeaderRow: {
    flexDirection: 'row',
    backgroundColor: PDF_COLORS.BACKGROUND_LIGHT_GRAY,
    borderBottomWidth: PDF_LAYOUT.BORDER_WIDTH.THIN,
    borderBottomColor: PDF_COLORS.BORDER_MEDIUM,
  },

  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: PDF_LAYOUT.BORDER_WIDTH.THIN,
    borderBottomColor: PDF_COLORS.BORDER_LIGHT,
  },

  tableRowAlt: {
    flexDirection: 'row',
    borderBottomWidth: PDF_LAYOUT.BORDER_WIDTH.THIN,
    borderBottomColor: PDF_COLORS.BORDER_LIGHT,
    backgroundColor: PDF_COLORS.BACKGROUND_GRAY,
  },

  tableHeaderCell: {
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.XSMALL,
    fontWeight: 'bold',
    fontFamily: PDF_TYPOGRAPHY.FONT_FAMILY.BOLD,
    color: PDF_COLORS.TEXT_SECONDARY,
    padding: PDF_LAYOUT.SPACING.SMALL,
  },

  tableCell: {
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.XSMALL,
    color: PDF_COLORS.TEXT_PRIMARY,
    padding: PDF_LAYOUT.SPACING.SMALL,
    lineHeight: PDF_TYPOGRAPHY.LINE_HEIGHT.RELAXED,
  },
})
